import React from 'react'

import { LoadingIcon } from './loading-icon'

export const LoadingPage = () => (
    <div className="loading-page">
        <LoadingIcon color="white" />
    </div>
)
